// import { DoubleArrowDownIcon } from "@radix-ui/react-icons";
import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";

// import { Button } from "@/components/ui/button/button";
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@/components/ui/popover/popover";
// import { useStatusFilter } from "./hooks/use-status-filter";
// import { Separator } from "@/components/ui/separator/separator";
// import {
//   RadioGroup,
//   RadioGroupItem,
// } from "@/components/ui/radio-group/radio-group";
// import { Label } from "@/components/ui/label/label";

import { DateRangePicker } from "./_components/_components/month-picker/date-range-picker2";
import { useDateRangeStore } from "./_components/_components/month-picker/use-date-range-store";
import { fetchAllAttendanceRequestForEmployeeQueryOptions } from "@/config/queries/emp-query-options";
import { convertUTCtoIST } from "@/utils";
import { Spinner } from "@/components/ui/spinner/spinner";
import { DataTable } from "./_components/_components/leads-table/data-table";
import { getColumns } from "./_components/_components/leads-table/columns";
import { AttendanceRequest } from "./_components/_components/leads-table/schema";

const EmployeeAttendanceRequests = () => {
  // const { filter, setFilter } = useStatusFilter();
  const key = Cookies.get("key") as string;

  const { dateRange } = useDateRangeStore();

  const startdate = dateRange?.from as Date;
  const enddate = dateRange?.to as Date;

  const { data, isPending, isFetching } = useQuery(
    fetchAllAttendanceRequestForEmployeeQueryOptions(key, {
      startdate: convertUTCtoIST(new Date(startdate.setHours(0))),
      enddate: convertUTCtoIST(new Date(enddate.setHours(23))),
      // status: filter,
    })
  );

  const requestsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.requests === undefined) {
      return [];
    }

    const result = data?.requests?.map((request) => {
      return {
        id: request?._id,
        notes: request?.notes,
        status: request?.status,
        date: request?.date,
        createdAt: request?.createdAt,
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  const columns = useMemo<ColumnDef<AttendanceRequest, unknown>[]>(
    () => getColumns(),
    []
  );

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center">
        <h3 className="text-2xl font-medium">Attendance Requests</h3>

        <div className="flex items-center gap-2 ml-auto">
          {/* <Popover>
            <PopoverTrigger>
              <Button
                className="mr-3 flex items-center gap-2"
                size="sm"
                variant="outline"
              >
                <DoubleArrowDownIcon className="w-4 h-4" />
                Filter
                {filter && (
                  <>
                    <Separator orientation="vertical" />
                    {filter}
                  </>
                )}
              </Button>
            </PopoverTrigger>
            <PopoverContent>
              <RadioGroup
                value={filter}
                onValueChange={(value: "Pending" | "Approved" | "Rejected") => {
                  setFilter(value);
                }}
              >
                <div className="flex items-center space-x-2 cursor-pointer w-fit">
                  <RadioGroupItem value="Pending" id="pending" />
                  <Label htmlFor="pending">Pending</Label>
                </div>
                <div className="flex items-center space-x-2 cursor-pointer w-fit">
                  <RadioGroupItem value="Approved" id="approved" />
                  <Label htmlFor="approved">Approved</Label>
                </div>
                <div className="flex items-center space-x-2 cursor-pointer w-fit">
                  <RadioGroupItem value="Rejected" id="rejected" />
                  <Label htmlFor="rejected">Rejected</Label>
                </div>
              </RadioGroup>
            </PopoverContent>
          </Popover> */}

          <DateRangePicker />
        </div>
      </div>

      {isPending ? (
        <div className="h-20 mt-10 flex items-center justify-center">
          <Spinner size="small">
            <p>Searching for Attendance Requests...</p>
          </Spinner>
        </div>
      ) : data?.requests?.length ? (
        <div className="mt-5">
          <DataTable data={requestsData} columns={columns} />
        </div>
      ) : (
        <div className="border h-20 flex items-center justify-center mt-5">
          No Attendance Request
        </div>
      )}
    </div>
  );
};

export default EmployeeAttendanceRequests;
